import { NumberInput } from '@frontend/components/basic-forms';
import { updateField } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useStockConstraintDataInput from './stock-constraint-data-input.controller';

const ID = 'stock-constraint-data-input';
export interface StockConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const StockConstraintDataInput = (props: StockConstraintDataInputProps) => {
    const viewProps = useStockConstraintDataInput(props);

    return (
        <div
            id={ID}
            className='flex w-full flex-row'>
            <NumberInput
                required
                value={viewProps.formValues?.quantity ?? undefined}
                onChange={(v) => {
                    props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { quantity: v } : undefined }));
                }}
                label='Quantity'
            />
        </div>
    );
};

export default StockConstraintDataInput;
